var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.886 11c0-6.075-4.925-11-11-11h-269.268c-2.941 0-5.607 1.161-7.58 3.042-.001 0-.013-.001-.013-.001l-28.511 27.201h-184.461c-6.075 0-11 4.925-11 11v431.218c0 21.803 17.737 39.54 39.54 39.54h438.182c18.843 0 34.173-15.33 34.173-34.173zm-280.268 94.182c6.075 0 11-4.925 11-11v-72.182h247.269v185.235h-334.457v-102.053zm-11-22h-48.723l48.723-46.484zm-198.565 389.278v-420.218h150.401l-35.617 33.98c-2.217 2.115-3.403 5.006-3.405 7.954 0 0-.002.005-.002.005v.065.01 112.979h-61.293c-6.075 0-11 4.925-11 11v252.661c0 10.534-8.57 19.104-19.104 19.104h-2.441c-9.671 0-17.539-7.868-17.539-17.54zm455.721 17.54h-399.362c3.012-5.712 4.726-12.21 4.726-19.104v-241.661h406.749l.061 248.592c-.001 6.712-5.462 12.173-12.174 12.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.768 388.125h-23.191v-23.19c0-6.075-4.925-11-11-11s-11 4.925-11 11v23.19h-23.19c-6.075 0-11 4.925-11 11s4.925 11 11 11h23.19v23.191c0 6.075 4.925 11 11 11s11-4.925 11-11v-23.191h23.191c6.075 0 11-4.925 11-11s-4.924-11-11-11z",
    fill: "#3cc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m244.18 383.909h-101.007c-6.075 0-11-4.925-11-11s4.925-11 11-11h101.007c6.075 0 11 4.925 11 11s-4.924 11-11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.18 444.316h-101.007c-6.075 0-11-4.925-11-11s4.925-11 11-11h101.007c6.075 0 11 4.925 11 11s-4.924 11-11 11z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.4e783f542ff1dd2dffe8df7de135351a.svg";
export { ForwardRef as ReactComponent };